import React from 'react'

import { Typography, Grid, Box, Card } from '@material-ui/core'
import styles from '../settingsStyles'
import { credits } from './credits.constants'
import BackButtonNavBar from '../../../CommonComponents/BackButtonNavBar/BackButtonNavBar'
import useSettingsBack from '../../../helpers/useSettingsBack'

function Credits() {
  const classes = styles()
  const goBackButton = useSettingsBack('Credits', '/settings')
  return (
    <Box className={classes.settingsNavBar}>
      <BackButtonNavBar
        onClick={goBackButton}
        name="Credits"
        topMargin={{ xs: 56, sm: 64, md: 64, lg: 64 }}
      />
      <Box className={classes.centerPage}>
        <Grid
          container
          direction="column"
          alignItems="center"
          className={classes.container}
          wrap="nowrap"
        >
          <Grid item className={classes.fullWidth}>
            <Card className={classes.linksCard}>
              <Grid
                container
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={2}
                className={classes.creditsCard}
              >
                <Grid item>
                  <Typography variant="h2">Meet the myRutgers team</Typography>
                </Grid>
                <Grid
                  item
                  container
                  direction="row"
                  justifyContent="space-evenly"
                >
                  <Grid
                    item
                    container
                    direction="column"
                    alignItems="center"
                    justifyContent="flex-start"
                    spacing={2}
                    xs={4}
                  >
                    <Grid item>
                      <Typography variant="h4">Mobile</Typography>
                    </Grid>
                    <Grid
                      item
                      container
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                    >
                      {credits.mobile.map((credit) => (
                        <Typography variant="body1" key={credit}>
                          {credit}
                        </Typography>
                      ))}
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    container
                    direction="column"
                    xs={4}
                    spacing={2}
                    alignItems="center"
                    justifyContent="flex-start"
                  >
                    <Grid item>
                      <Typography variant="h4">Web</Typography>
                    </Grid>
                    <Grid
                      item
                      container
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                    >
                      {credits.web.map((credit) => (
                        <Typography variant="body1" key={credit}>
                          {credit}
                        </Typography>
                      ))}
                    </Grid>
                  </Grid>
                  <Grid
                    item
                    container
                    direction="column"
                    xs={4}
                    spacing={2}
                    alignItems="center"
                    justifyContent="flex-start"
                  >
                    <Grid item>
                      <Typography variant="h4">Backend</Typography>
                    </Grid>
                    <Grid
                      item
                      container
                      direction="column"
                      alignItems="center"
                      justifyContent="center"
                    >
                      {credits.backend.map((credit) => (
                        <Typography variant="body1" key={credit}>
                          {credit}
                        </Typography>
                      ))}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item>
                  <Typography variant="h4">System Architect</Typography>
                </Grid>
                <Grid
                  item
                  container
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  {credits.systemArchitect.map((credit) => (
                    <Typography variant="body1" key={credit}>
                      {credit}
                    </Typography>
                  ))}
                </Grid>
                <Grid item>
                  <Typography variant="h4">Past Contributors</Typography>
                </Grid>
                <Grid
                  item
                  container
                  direction="column"
                  alignItems="center"
                  justifyContent="center"
                >
                  {credits.pastContributors.map((credit) => (
                    <Typography variant="body1" key={credit}>
                      {credit}
                    </Typography>
                  ))}
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default Credits
